import { render, staticRenderFns } from "./PurchasingReturnNoteModal.vue?vue&type=template&id=28253b58"
import script from "./PurchasingReturnNoteModal.vue?vue&type=script&lang=js"
export * from "./PurchasingReturnNoteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports